import { SupportLinkList } from 'common/components/support-link-list'
import { IMPORTANT_ANNOUNCEMENTS_URL, MAINTENANCE_ANNOUNCEMENTS_URL } from 'common/constants'
import { getNs } from 'common/i18n-config'
import { SessionHeader } from 'components/organisms'
import React, { useEffect } from 'react'

import { StyledContent, StyledTitle, StyledWrapper } from '../styles'

const { t, useNsReady } = getNs(['pages/error-pages', 'common'])
const InternalServerErrorPage = () => {
  useNsReady()

  useEffect(() => {
    document.title = t('page_title')
  }, [])

  const supportLinks = [
    { text: t('important_announcements'), href: IMPORTANT_ANNOUNCEMENTS_URL },
    { text: t('maintenance_announcements'), href: MAINTENANCE_ANNOUNCEMENTS_URL },
  ]

  return (
    <>
      <SessionHeader />
      <StyledWrapper>
        <StyledTitle>{t('internal_server_error.title')}</StyledTitle>
        <StyledContent>{t('internal_server_error.content')}</StyledContent>
        <SupportLinkList links={supportLinks} />
      </StyledWrapper>
    </>
  )
}

export default InternalServerErrorPage
